export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "La recherche de produits, organisée",

  "nav.home": "Accueil",
  "nav.buyingGuide": "Guide d'achat",
  "nav.guide": "Guide du Spreadsheet",
  "nav.categories": "Catégories",
  "nav.faq": "FAQ",

  "buttons.allchinabuySpreadsheet": "AllChinaBuy Spreadsheet",
  "buttons.buyItNow": "Acheter maintenant",
  "buttons.viewCategory": "Voir la catégorie",
  "buttons.browse": "Tout parcourir",

  "categories.shoes": "Chaussures",
  "categories.hoodies": "Sweats à capuche / Pulls",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons / Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",

  "languages.en": "English",
  "languages.fr": "Français",
  "languages.da": "Dansk",
  "languages.de": "Deutsch",

  "footer.disclaimer": "Ressource indépendante · Pas le site officiel AllChinaBuy",
  "footer.rights": "Tous droits réservés.",
  "footer.explore": "Explorer",
  "footer.resources": "Ressources",
  "footer.backHome": "Retour à l'accueil",
  "footer.browseCategories": "Parcourir les catégories",
};